"use strict";
(self["webpackChunkretail_klant_conversational_asn"] = self["webpackChunkretail_klant_conversational_asn"] || []).push([[305],{

/***/ 7457
(module) {

module.exports = /*#__PURE__*/JSON.parse('{"klant.conversational.connector.error.message":{"default":"Sorry, de chat is even niet beschikbaar. Probeer het later nog eens."},"klant.conversational.connector.error.message.reload":{"default":"Opnieuw laden."}}');

/***/ },

/***/ 3837
(module) {

module.exports = /*#__PURE__*/JSON.parse('{"conversational.chat.container.title":{"default":"Chat","reb":"Digitale hulplijn"}}');

/***/ },

/***/ 1781
(module) {

module.exports = /*#__PURE__*/JSON.parse('{"conversational.chat.disclaimer.title":{"default":"Goed om te weten:"},"conversational.chat.disclaimer.message":{"default":"Om onze dienstverlening te kunnen verbeteren, bewaren we dit gesprek (<a target=\'_blank\' href=\'https://www.asnbank.nl/privacy/privacy-en-cookiereglement.html\'>meer informatie</a>).","asn":"Om onze dienstverlening te kunnen verbeteren, bewaren we dit gesprek (<a target=\'_blank\' href=\'https://www.asnbank.nl/privacy/privacy-en-cookiereglement.html\'>meer informatie</a>).","blg":"Om onze dienstverlening te kunnen verbeteren, bewaren we dit gesprek (<a target=\'_blank\' href=\'https://www.asnbank.nl/privacy/privacy-en-cookiereglement.html\'>meer informatie</a>).","reb":"Om onze dienstverlening te kunnen verbeteren, bewaren we dit gesprek (<a target=\'_blank\' href=\'https://www.regiobank.nl/privacy-en-cookiereglement/regiobank-en-uw-privacy.html\'>meer informatie</a>).","sns":"Om onze dienstverlening te kunnen verbeteren, bewaren we dit gesprek (<a target=\'_blank\' href=\'https://www.snsbank.nl/particulier/service/privacy-amp-cookies/privacy-cookiereglement.html\'>meer informatie</a>)."}}');

/***/ },

/***/ 8068
(module) {

module.exports = /*#__PURE__*/JSON.parse('{"conversational.chat.connectionerror.title":{"default":"Verbindingsproblemen"},"conversational.chat.connectionerror.message":{"default":"Er is mogelijk een probleem met je internetverbinding. De chatsessie wordt hervat als de verbinding weer beschikbaar is."}}');

/***/ },

/***/ 7914
(module) {

module.exports = /*#__PURE__*/JSON.parse('{"conversational.chat.retryconnectionerror.title":{"default":"Er ging iets mis..."},"conversational.chat.retryconnectionerror.message":{"default":"Wil je een nieuwe chatsessie starten?"},"conversational.chat.retryconnectionerror.button":{"default":"Herstart chat"}}');

/***/ },

/***/ 7571
(module) {

module.exports = /*#__PURE__*/JSON.parse('{"conversational.chat.inactivityprompt.title":{"default":"Wil je doorgaan met het gesprek?"},"conversational.chat.inactivityprompt.button.continue":{"default":"Doorgaan"},"conversational.chat.inactivityprompt.button.stop":{"default":"Beëindigen"}}');

/***/ },

/***/ 4217
(module) {

module.exports = /*#__PURE__*/JSON.parse('{"conversational.chat.safety.notification":{"default":"Deel nooit vertrouwelijke gegevens zoals je pincode.","blg":"Deel nooit vertrouwelijke gegevens zoals wachtwoorden en inlogcodes."},"conversational.chat.input.field.label":{"default":"Jouw bericht"}}');

/***/ },

/***/ 2947
(module) {

module.exports = /*#__PURE__*/JSON.parse('{"conversational.chat.message.message.chatbot":{"default":"Bericht van chatbot"},"conversational.chat.message.message.agent":{"default":"Bericht van medewerker"},"conversational.chat.message.message.own":{"default":"Jouw bericht"},"conversational.chat.message.message.other":{"default":"Bericht"}}');

/***/ },

/***/ 2501
(module) {

module.exports = /*#__PURE__*/JSON.parse('{"conversational.chat.overlay.message.title":{"default":"Je bent nog in gesprek. Stel je vraag aan de medewerker, die helpt je verder."},"conversational.chat.overlay.message.button.continue":{"default":"Doorgaan"}}');

/***/ },

/***/ 3953
(module) {

module.exports = /*#__PURE__*/JSON.parse('{"klant.conversational.aria.chatmessages":{"default":"Alle chatberichten"},"klant.conversational.aria.inputarea":{"default":"Chat input"},"klant.conversational.aria.istyping":{"default":"Medewerker is aan het typen"}}');

/***/ },

/***/ 6631
(module) {

module.exports = /*#__PURE__*/JSON.parse('{"mijn.klant.conversational.error.message":{"default":"Sorry, de chat is even niet beschikbaar. Probeer het later nog eens."},"mijn.klant.conversational.takeover.error.message":{"default":"Sorry, de chat is even niet beschikbaar. <br/>Probeer het later nog eens."}}');

/***/ },

/***/ 4925
(module) {

module.exports = /*#__PURE__*/JSON.parse('{"conversational.link.button.label":{"default":"Start chatgesprek"}}');

/***/ },

/***/ 3977
(module) {

module.exports = /*#__PURE__*/JSON.parse('{"retail.klant.conversational.takeover.error.message":{"default":"Sorry, de chat is even niet beschikbaar. <br/>Probeer het later nog eens."}}');

/***/ }

}]);